import React from "react";
import "../styles/flexSection.scss";
import { Button } from "../styles/styles";
import image1 from "../assets/images/img 1.webp";
import image2 from "../assets/images/img 2.webp";
import image4 from "../assets/images/img 4.webp";
import image5 from "../assets/images/img 5.webp";
import image6 from "../assets/images/img 6.webp";
import mac from "../assets/images/mac.webp";
import iphone from "../assets/images/iphone.webp";
import macGif from "../assets/images/mac gif.gif";
import phoneGif from "../assets/images/phone gif.gif";
import { Link } from "react-router-dom";
// import AppContext from "../context/context";

function FlexSection() {
  // const { handleTopOn } = useContext(AppContext);
  return (
    <section id="flex-section">
      <div className="holder">
        <div className="img-con-1">
          <img src={image1} alt="fund-app" />
        </div>
        <div className="text-box">
          <h2>Fundall App</h2>
          <p>
            Design Fundall.io to appeal to underserved users, create virality
            and community within their audience.
          </p>
          <Link to="/404">
            {" "}
            <Link to='/fundall'>
              <Button className="btn">View Details</Button>
            </Link>
          </Link>
        </div>
      </div>
      <div className="holder rev">
        <div className="img-con-2">
          <img src={image2} alt="fund-app" />
        </div>
        <div className="text-box ">
          <h2>Tra-it AR App</h2>
          <p>
            Tra-it AR offers virtual 'try-out' of ecommerce products, from
            furniture to clothes, in true-to-scale AR view, before purchase.{" "}
          </p>
          <Link to="/trait">
            {" "}
            <Button className="btn">View Details</Button>
          </Link>
        </div>
      </div>
      <div className="holder">
        <div className="img-con-3">
          <img src={mac} alt="fund-app" className="mac" />
          <img src={macGif} alt="fund-app" className="mac-gif" />
          <img src={iphone} alt="fund-app" className="iphone" />
          <img src={phoneGif} alt="fund-app" className="phone-gif" />
        </div>
        <div className="text-box">
          <h2>OpsPad</h2>
          <p>
            OpsPad streamlines DevOps workflow with a minimalist notepad design
            for monitoring and analyzing infrastructure performance.{" "}
          </p>
          <Link to="/404">
            {" "}
            <Button className="btn">View Details</Button>
          </Link>
        </div>
      </div>
      <div className="holder rev">
        <div className="img-con-4">
          <img src={image4} alt="fund-app" />
        </div>
        <div className="text-box ">
          <h2>Klippay</h2>
          <p>
            Personal banking and internal dashboard for the web and mobile
            interface of Klippay, an African based SME Bank.{" "}
          </p>
          <Link to="/404">
            {" "}
            <Button className="btn">View Details</Button>
          </Link>
        </div>
      </div>
      <div className="holder">
        <div className="img-con-5">
          <img src={image5} alt="fund-app" />
        </div>
        <div className="text-box">
          <h2>PDR</h2>
          <p>
            Design web app to prevent Duplicate Reversals by identifying and
            excluding auto-reversal transactions.
          </p>
          <Link to="/404">
            {" "}
            <Button className="btn">View Details</Button>
          </Link>
        </div>
      </div>
      <div className="holder rev">
        <div className="img-con-6">
          <img src={image6} alt="fund-app" />
        </div>
        <div className="text-box ">
          <h2>Bucks</h2>
          <p>
            Design UI for Bucks app: kids save and manage finances under
            parental supervision. Landing page and mobile app.
          </p>
          <Link to="/404">
            {" "}
            <Button className="btn">View Details</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default FlexSection;
